<div
  class="image-preview-container"
  [popper]="tooltipcontent"
  [popperTrigger]="popperTrigger"
  [popperDelay]="delay"
  [popperPlacement]="position"
  [popperPositionFixed]="popperPositionFixed"
  [popperHideOnMouseLeave]="popperHideOnMouseLeave"
  [popperShowOnStart]="popperShowOnStart"
  [popperAppendTo]="appendTo"
  (popperOnShown)="onShown()"
  [class.no-status]="!hasStatus"
>
  <span
    class="image-preview-status-icon"
    [class.active]="isActive"
    [class.inactive]="isInactive"
    [class.pending]="isPending"
    [class.active-bottom]="isActiveBottom"
    [style.background-color]="statusColor"
  >
  </span>
  <span class="image-preview-image-container">
    <ngx-skeleton-loader
      *ngIf="!thumbnailBase64 && loading.thumbnail"
      style="height: 100%; width: 100%"
      [theme]="{
        height: '100%',
        width: '100%'
      }"
    ></ngx-skeleton-loader>
    <img
      class="image-preview-image {{ imageFit }}"
      [class.hidden]="!thumbnailBase64 && loading.thumbnail"
      [class.fallback]="errors.thumbnail"
      [src]="thumbnailSource"
      (load)="onImgLoad('thumbnail')"
      (error)="onImgError('thumbnail')"
    />
  </span>
</div>

<popper-content
  #tooltipcontent
  class="image-popover"
  (click)="preventPropagation()"
>
  <div class="image-popover-content">
    <div class="image-popover-image-container">
      <ngx-skeleton-loader
        style="height: 100%; width: 100%"
        *ngIf="!imageBase64 && loading.image"
        [theme]="{
          height: '100%',
          width: '100%'
        }"
      ></ngx-skeleton-loader>
      <img
        class="image-popover-image"
        [src]="imageSource"
        [class.hidden]="!imageBase64 && loading.image"
        [class.fallback]="localImage"
        *ngIf="tooltipContentVisible"
        (load)="onImgLoad('image')"
        (error)="onImgError('image')"
      />
    </div>
    <div class="image-popover-footer" *ngIf="hasStatus || isImageIllustrative">
      <ng-container *ngIf="hasStatus">
        <span
          class="image-preview-status-icon"
          style="height: 40px"
          *ngIf="description"
          [class.active]="isActive"
          [class.inactive]="isInactive"
          [class.pending]="isPending"
          [class.active-bottom]="isActiveBottom"
        >
        </span>
        <div class="image-popover-status-container ml10">
          <div class="align-center flex flex-row">
            <span
              class="image-popover-status-icon"
              *ngIf="!description"
              [class.active]="isActive"
              [class.inactive]="isInactive"
              [class.pending]="isPending"
              [style.background-color]="statusColor"
            >
            </span>
            <!-- <status-circle [status]="status" [enum]="type === 'product' ? 'SupplierProductAssortmentStatus' : 'Status'"></status-circle> -->
            <span class="image-popover-status-text">
              <span>{{
                statusText ? statusText : (status | translateEnum: statusEnum)
              }}</span>
            </span>
          </div>
          <div *ngIf="description" class="align-center ml5 flex">
            <span style="font-size: 12px">
              {{ description }}
            </span>
          </div>
        </div>
      </ng-container>

      <div class="image-illustrative-text" *ngIf="isImageIllustrative">
        {{ "global.image_is_illustrative" | translate }}
      </div>
    </div>
  </div>
</popper-content>
